module.exports = __webpack_public_path__ + "static/media/om_hairstyle_receding_front_vector.d4c2bf93.svg";